export const environment = {
    production: true,
    GOOGLE_KEY: "AIzaSyDlR9F_WfSAzcxk_PUfGopOffOXM74794o",
    API_URL: "https://fms-panel.connexis.tech/",
    PREFIX: "api/",
    PAGINATION: 25,
};
